import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EventEmitterService } from 'src/app/services/event-emitter.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  user;
  changeForm: FormGroup;
  inputType1 = 'password';
  showHide1 = '../../../../assets/hide.svg';
  inputType2 = 'password';
  showHide2 = '../../../../assets/hide.svg';
  inputType3 = 'password';
  showHide3 = '../../../../assets/hide.svg';
  isError = false;
  isErrorText = 'form-is-not-valid';

  constructor(
    public modalController: ModalController,
    private authenticationService: AuthenticationService,
    private usersService: UsersService,
    private eventEmitterService: EventEmitterService,
    private fb: FormBuilder
  ) {
    this.user = this.authenticationService.userValue;
  }

  ngOnInit() {
    this.isError = false;
    this.isErrorText = 'form-is-not-valid';
    this.initForm();
  }

  initForm() {
    this.changeForm = this.fb.group({
      old_password: new FormControl('', Validators.required),
      new_password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
      ]),
      confirm_new_password: new FormControl('', Validators.required),
    });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  async save() {
    this.isError = false;
    this.isErrorText = 'something-went-wrong';

    if (this.changeForm.get('old_password').invalid) {
      this.isError = true;
      this.isErrorText = 'there-are-empty-fields';
      return;
    }

    if (this.changeForm.get('new_password').invalid) {
      this.isError = true;
      this.isErrorText = 'password-is-not-valid';
      return;
    }

    if (
      this.changeForm.get('new_password').value !==
      this.changeForm.get('confirm_new_password').value
    ) {
      this.isError = true;
      this.isErrorText = 'passwords-are-not-equal';
      return;
    }

    this.usersService.changePassword(this.changeForm.value).subscribe(
      (res) => {
        this.eventEmitterService.userUpdated();
        this.changeForm.reset();
        this.inputType1 = 'password';
        this.showHide1 = '../../../../assets/hide.svg';
        this.inputType2 = 'password';
        this.showHide2 = '../../../../assets/hide.svg';
        this.inputType3 = 'password';
        this.showHide3 = '../../../../assets/hide.svg';
        this.isError = false;
        this.isErrorText = 'something-went-wrong';
        this.closeModal();
      },
      (error) => {
        this.isError = true;
        this.isErrorText = 'something-went-wrong';
      }
    );
  }

  showHideField(numri: any) {
    if (numri === 1) {
      if (this.inputType1 === 'password') {
        this.inputType1 = 'text';
        this.showHide1 = '../../../../assets/show.svg';
      } else {
        this.inputType1 = 'password';
        this.showHide1 = '../../../../assets/hide.svg';
      }
    }
    if (numri === 2) {
      if (this.inputType2 === 'password') {
        this.inputType2 = 'text';
        this.showHide2 = '../../../../assets/show.svg';
      } else {
        this.inputType2 = 'password';
        this.showHide2 = '../../../../assets/hide.svg';
      }
    }
    if (numri === 3) {
      if (this.inputType3 === 'password') {
        this.inputType3 = 'text';
        this.showHide3 = '../../../../assets/show.svg';
      } else {
        this.inputType3 = 'password';
        this.showHide3 = '../../../../assets/hide.svg';
      }
    }
  }
}
